import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * DTO público para planes de suscripción
 * Sincronizado con ChatbotPezeta.Dtos.Public.PublicSubscriptionPlanDTO
 */
export interface PublicSubscriptionPlan {
  name: string;
  code: string;
  description: string;
  defaultMonthlyMessageLimit: number;
  defaultMaxUsers: number;
  defaultMaxLeads: number;
  defaultMonthlyPrice: number;
  defaultCurrency: string;
  trialDays: number;
  displayOrder: number;
}

/**
 * Servicio para endpoints públicos (sin autenticación requerida)
 * Utilizado principalmente en la landing page y páginas públicas
 */
@Injectable({
  providedIn: 'root'
})
export class PublicService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Obtiene los planes de suscripción activos disponibles públicamente
   * Endpoint: GET /api/public/subscription-plans
   * No requiere autenticación
   * @returns Observable con array de planes ordenados por displayOrder
   */
  getSubscriptionPlans(): Observable<PublicSubscriptionPlan[]> {
    return this.http.get<PublicSubscriptionPlan[]>(`${this.apiUrl}/api/public/subscription-plans`);
  }
}
